EXE(function() {
	if($('*').is('.fixed-header')) {
		/*фиксация шапки без битрикс панели*/
		function innerHeader() {
			//$('.fixed-header').closest('body').css('paddingTop', `${$('.fixed-header').outerHeight()}px`);
			$('.fixed-header').next().css('marginTop', `${$('.fixed-header').outerHeight()}px`);
			$('.fixed-header').css({'position': 'fixed', 'top' : '0px', 'left': '0px', 'right': '0px', 'zIndex' : '1020'});
		};
		/*Фиксануть шапки с учетом битрикс панели*/
		function bitrixPannelOpen() {
			if($('#bx-panel').is('.bx-panel-fixed')) {
				$('.fixed-header').closest('body').css('paddingTop', `${$('.fixed-header').outerHeight()}px`);
				$('.fixed-header').css({'position': 'fixed', 'top' : `${$('#bx-panel').height()}px`, 'left': '0px', 'right': '0px', 'zIndex' : '1020'});
			} else {
				$('.fixed-header').closest('body').css('paddingTop', `0px`);
				$('.fixed-header').css({'position': 'static'});
			}
		}
		/*скрипт который фиксирует header*/
		if($('div').is('#bx-panel')) {
			/*если есть битрикс панель*/
			bitrixPannelOpen();
			$('#bx-panel-pin').on('click', function() {
				if($('#bx-panel-pin').is('.bx-panel-pin-fixed')) {
					bitrixPannelOpen();
				} else {
					bitrixPannelOpen();
				}
			});
		} else {
			/*зафиксировать шапку без битрикс панели*/
			innerHeader();
			$(window).resize(function() {
				innerHeader();
			});
		}
	}
});




// WEBPACK FOOTER //
// ./libs/fixed-header.js